export const DataNeo = [
    {
        id: 1,
        image: "/Images/Child/Neonatology/Preterm-Birth-Neonatology-Sivaganaga.webp",
        title: "Preterm Birth",
        subTitle:"The delivery of a baby before 37 completed weeks of gestation",
    },
    {
        id: 2,
        image: "/Images/Child/Neonatology/Birth-Asphyxia-Neonatology-Sivaganaga.webp",
        title: "Birth Asphyxia",
        subTitle:"A condition where a newborn baby fails to initiate or sustain breathing at birth due to a lack of oxygen supply",
    },
    {
        id: 3,
        image: "/Images/Child/Neonatology/Meconium aspiration-Neonatology-Sivaganaga.webp",
        title: "Meconium aspiration",
        subTitle:"A condition where a newborn baby inhales a mixture of meconium (their first stool) and amniotic fluid during delivery, causing respiratory distress due to the obstruction of their airways by the thick, sticky substance",
    },
    {
        id: 4,
        image: "/Images/Child/Neonatology/Neonatal-seizure-Neonatology-Sivaganaga.webp",
        title: "Neonatal seizure",
        subTitle:"Seizures that occur in a newborn baby during the first few weeks of life, characterized by sudden, abnormal electrical activity in the brain, often manifesting as subtle or overt muscle movements, and typically requiring specialized monitoring and treatment due to the unique developmental stage of the newborn brain.",
    },
    {
        id: 5,
        image: "/Images/Child/Neonatology/Neonatal Sepsis-Neonatology-Sivaganaga.webp",
        title: "Neonatal Sepsis",
        subTitle:"A life-threatening bloodstream infection that occurs in a newborn baby (within the first month of life), often caused by bacteria, and can manifest with various non-specific symptoms like lethargy, poor feeding, temperature instability, and respiratory distress, requiring immediate medical attention and antibiotic treatment.",
    },
    {
        id: 6,
        image: "/Images/Child/Neonatology/Newborn-jaundice-Neonatology-Sivaganaga.webp",
        title: "Newborn jaundice",
        subTitle:"A yellow discoloration of a baby's skin and eyes, caused by a buildup of bilirubin in the blood, which is a byproduct of red blood cell breakdown.",
    },
    {
        id: 7,
        image: "/Images/Child/Neonatology/Respiratory Distress Syndrome (RDS)-Neonatology-Sivaganaga.webp",
        title: "Respiratory Distress Syndrome (RDS)",
        subTitle:"Occurs in babies born early (premature) whose lungs are not fully developed",
    },
    {
        id: 8,
        image: "/Images/Child/Neonatology/HFNC-Neonatology-Sivaganaga.webp",
        title: "High-flow nasal cannula (HFNC) oxygen therapy",
        subTitle:"Provide non-invasive respiratory support to newborn babies.",
    },
    {
        id: 9,
        image: "/Images/Child/Neonatology/Phototherapy-Neonatology-Sivaganaga.webp",
        title: "Phototherapy",
        subTitle:"A treatment that uses a special type of light to treat jaundice in newborns.",
    },
    {
        id: 10,
        image: "/Images/Child/Neonatology/Hearing Screening-Neonatology-Sivaganaga.webp",
        title: "Hearing Screening",
        subTitle:"A standard procedure in hospitals that checks for hearing loss in babies.",
    },
    {
        id: 11,
        image: "/Images/Child/Neonatology/Metabolic Screening-Neonatology-Sivaganaga.webp",
        title: "Metabolic Screening",
        subTitle:"A blood test that checks for rare but serious metabolic disorders in newborns.",
    },
    {
        id: 12,
        image: "/Images/Child/Neonatology/Thyroid Scan-Neonatology-Sivaganaga.webp",
        title: "Thyroid Scan",
        subTitle:"A diagnostic procedure, which helps assess how well your baby's thyroid gland is functioning.",
    },
    {
        id: 13,
        image: "/Images/Child/Neonatology/Well Baby Clinic-Neonatology-Sivaganaga.webp",
        title: "Well Baby Clinic",
        subTitle:"A health-service clinic for preventive monitoring, health education and advice for parents of babies.",
    },
];
